// @material-ui
import { makeStyles } from '@material-ui/styles'

export const useBlockedMoneyNoticeStyle = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(4),
  },

  title: {},

  amount: {
    marginLeft: theme.spacing(2),
  },

  account: {
    fontWeight: theme.typography.fontWeightBold,
  },
}))
